import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
import useIsMobile from "@/common/hooks/useIsMobile";
import Markdown from "markdown-to-jsx";
var UPDATING_DELAY_MS = 1000;
var WarrantyOptionRow = function WarrantyOptionRow(_ref) {
  var _option$badge$backgro, _option$badge;
  var option = _ref.option,
    isSelected = _ref.isSelected,
    onSelect = _ref.onSelect,
    showBadge = _ref.showBadge;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var isFree = !option.price;
  var _useState = useState(false),
    wasClicked = _useState[0],
    setWasClicked = _useState[1];
  var timerRef = useRef(null);
  var hasBadge = Boolean(option.badge) || Boolean(option.badge_label);
  useEffect(function () {
    if (!isSelected) setWasClicked(false);
  }, [isSelected]);
  var handleClick = function handleClick() {
    if (isSelected) return;
    if (isMobile) {
      onSelect(option);
      return;
    }
    setWasClicked(true);
    timerRef.current = setTimeout(function () {
      onSelect(option);
    }, UPDATING_DELAY_MS);
  };
  useEffect(function () {
    return function () {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  var glowColor = (_option$badge$backgro = (_option$badge = option.badge) === null || _option$badge === void 0 ? void 0 : _option$badge.background_color) !== null && _option$badge$backgro !== void 0 ? _option$badge$backgro : "#8E47E0";
  return /*#__PURE__*/React.createElement(motion.div, {
    role: "button",
    onClick: handleClick,
    animate: hasBadge && !isSelected && !wasClicked ? {
      boxShadow: ["0 0 0 1.5px ".concat(glowColor, "40, 0 0 0px 0px ").concat(glowColor, "00"), "0 0 0 2px ".concat(glowColor, "CC, 0 0 12px 2px ").concat(glowColor, "55"), "0 0 0 1.5px ".concat(glowColor, "40, 0 0 0px 0px ").concat(glowColor, "00")]
    } : null,
    transition: hasBadge && !isSelected && !wasClicked ? {
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    } : {
      duration: 0.2
    },
    className: twMerge("w-full flex flex-col px-3 py-2 rounded border text-start transition-colors bg-[#FBFBFB] border-gray-gainsboro border-solid cursor-pointer relative", (isSelected || wasClicked) && "bg-blue-lavender border-primary-new", hasBadge && !isSelected && "border-violet")
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-navy-primary text-xs font-semibold leading-none"
  }, option.name)), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-cool text-[11px] font-normal leading-6"
  }, option.mileage)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 shrink-0"
  }, isFree ? /*#__PURE__*/React.createElement("span", {
    className: "text-gray-cool text-xs font-medium"
  }, tShort("remaining/free", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center opacity-80"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "text-[0px] relative [&_del]:text-sm [&_del]:font-bold [&_del]:leading-6 [&_del]:text-gray-cool [&_del]:no-underline [&_del]:relative [&_del]:after:content-[''] [&_del]:after:absolute [&_del]:after:inset-x-0 [&_del]:after:top-[50%] [&_del]:after:h-px [&_del]:after:bg-current [&_.syarah-currency-icon]:text-sm [&_.syarah-currency-icon]:text-gray-cool"
  }, option.original_price)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-navy-primary text-base font-bold leading-none"
  }, option.price))))), !isMobile && wasClicked && /*#__PURE__*/React.createElement("div", {
    className: "w-full p-3 bg-white text-start rounded-lg font-medium text-navy-primary text-xs"
  }, tShort("remaining/updating_warranty_in_progress", {
    ns: "web_tracking"
  })), option.badge_label && /*#__PURE__*/React.createElement("div", {
    className: "bg-violet flex items-center gap-1 px-1.5 py-0.5 rounded absolute top-[-10px] left-1/2 -translate-x-1/2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-white text-[10px] font-normal leading-4"
  }, option.badge_label), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--stars-2-outline-rounded",
    width: 3,
    height: 3,
    className: "text-white shrink-0"
  })));
};
export default WarrantyOptionRow;